<ng-container *ngIf="fondsPortfolioData$ | async as fondsPortfolioData">
  <div class="lv-uebersicht-portfolio">
  <ng-container
      *ngIf="fondsPortfolioData.isAnlagestrategieGemanagedZuzahlung || fondsPortfolioData.isAnlagestrategieIndividuellZuzahlung">
    <div class="lv-uebersicht-portfolio-section">
      <div class="lv-uebersicht-portfolio-section-titel-anlagestrategie">
        <ng-container *ngIf="fondsPortfolioData.isAnlagestrategieIndividuellZuzahlung">
          <div class="lv-uebersicht-portfolio-section-titel">Individuelles Portfolio</div>
        </ng-container>
        <ng-container *ngIf="fondsPortfolioData.isAnlagestrategieGemanagedZuzahlung">
          <div class="lv-uebersicht-portfolio-section-titel">{{ fondsPortfolioData.fondsgruppeNameZuzahlung }}</div>
        </ng-container>
        <div class="lv-uebersicht-fondsgruppe-details">
          <div class="lv-uebersicht-fondsgruppe-detail" *ngIf="!!fondsPortfolioData.artikelZuzahlung">
            Artikel {{ fondsPortfolioData.artikelZuzahlung }}
          </div>
          <div class="lv-uebersicht-fondsgruppe-detail">SRI {{ fondsPortfolioData.risikoklasseDurchschnittZuzahlung }}</div>
        </div>
      </div>
      <ng-container *ngIf="!!fondsPortfolioData.dataSourceZuzahlung?.data?.length">
        <lv-anlauf-ablauf-management-table class="lv-uebersicht-portfolio-table" matSortActive="name" matSortDirection="asc" matSort
                                           [isLastRowBold]="true"
                                           [dataSource]="fondsPortfolioData.dataSourceZuzahlung"></lv-anlauf-ablauf-management-table>
        <lv-donut-chart class="lv-uebersicht-portfolio-donut-chart" [data]="fondsPortfolioData.donutChartDataZuzahlung"
                        [url]="fondsPortfolioData.urlZuzahlung"></lv-donut-chart>
      </ng-container>
    </div>
  </ng-container>
  </div>
</ng-container>
